/* src/app/core/components/left-nav/left-nav.component.scss */
:host {
  display: contents;
}
#sidebar-wrapper {
  padding-right: 0.5rem;
  overflow: visible;
}
.left-nav-panel {
  --left-nav-bg: var(--brand-primary);
  --left-nav-shadow: color-mix(in srgb, var(--brand-primary) 28%, transparent);
  --left-nav-on-bg: var(--brand-on-primary);
  --left-nav-on-bg-muted: color-mix(in srgb, var(--white) 72%, transparent);
  --left-nav-hover: color-mix(in srgb, var(--white) 14%, transparent);
  --left-nav-chip-hover: color-mix(in srgb, var(--white) 20%, transparent);
  --left-nav-chip-active: color-mix(in srgb, var(--white) 92%, transparent);
  --left-nav-chip-shadow: 0 6px 14px color-mix(in srgb, var(--black) 18%, transparent);
  --left-nav-line: color-mix(in srgb, var(--white) 24%, transparent);
  --left-nav-badge-text: var(--brand-primary);
  --left-nav-submenu-bg: var(--brand-secondary);
  --left-nav-submenu-text: var(--brand-primary);
  --left-nav-menu-shadow: 0 16px 32px color-mix(in srgb, var(--black) 24%, transparent);
  --left-nav-logout: color-mix(in srgb, var(--brand-danger) 70%, var(--white));
  --left-nav-logout-hover: color-mix(in srgb, var(--brand-danger) 55%, var(--white));
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100vh - 1.55rem);
  height: calc(100dvh - 1.55rem);
  margin: 0.75rem 0;
  border-radius: 1rem;
  background: var(--left-nav-bg);
  color: var(--left-nav-on-bg);
  box-shadow: 0 16px 36px var(--left-nav-shadow);
  overflow: visible;
  -webkit-tap-highlight-color: transparent;
}
.left-nav-trigger,
.left-nav-subtrigger,
.left-nav-flyout-trigger,
.left-nav-account-trigger,
.left-nav-logout-trigger,
.left-nav-account-item,
.left-nav-account-subitem,
.left-nav-environment-badge {
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
}
.left-nav-header {
  display: flex;
  justify-content: center;
  padding: 1rem 0.5rem 0.25rem;
  flex: 0 0 auto;
}
.left-nav-logo {
  display: block;
  width: 2.5rem;
  height: 2.5rem;
  object-fit: contain;
  -webkit-touch-callout: none;
}
:host-context([data-brand=mf]) .left-nav-logo {
  width: 3.5rem;
  height: 3.5rem;
}
.left-nav-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--white) 28%, transparent) transparent;
}
.left-nav-scroll::-webkit-scrollbar {
  width: 0.45rem;
}
.left-nav-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.left-nav-scroll::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--white) 28%, transparent);
  border-radius: 999px;
}
.left-nav-menu {
  width: 100%;
}
.left-nav-list,
.left-nav-inline-submenu,
.left-nav-flyout-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.left-nav-list {
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
  padding: 0.5rem 0.5rem 1rem;
}
.left-nav-item {
  position: relative;
}
.left-nav-trigger,
.left-nav-subtrigger,
.left-nav-flyout-trigger {
  width: 100%;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}
.left-nav-trigger {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2.85rem;
  border-radius: 1rem;
  padding: 0.7rem 0;
  transition: background-color 180ms ease, color 180ms ease;
}
.left-nav-panel:not(.is-collapsed) .left-nav-trigger {
  justify-content: flex-start;
  gap: 0.875rem;
  padding: 0.8rem 0.9rem;
}
.left-nav-trigger.is-active .left-nav-icon-wrap,
.left-nav-item.is-inline-open > .left-nav-trigger .left-nav-icon-wrap {
  background: var(--left-nav-chip-active);
  box-shadow: var(--left-nav-chip-shadow);
}
.left-nav-trigger.is-active .left-nav-icon,
.left-nav-item.is-inline-open > .left-nav-trigger .left-nav-icon {
  color: var(--left-nav-bg);
}
.left-nav-icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  min-width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.35rem;
  transition:
    background-color 180ms ease,
    box-shadow 180ms ease,
    transform 120ms cubic-bezier(0.23, 1, 0.32, 1);
}
.left-nav-trigger:active .left-nav-icon-wrap {
  transform: scale(0.92);
}
.left-nav-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  min-width: 1.25rem;
  color: var(--left-nav-on-bg);
  line-height: 1;
  text-align: center;
  transition: color 180ms ease;
}
.left-nav-item[data-menu-id=NEW_QUOTATION] .left-nav-icon {
  color: var(--bs-success);
}
.left-nav-label {
  flex: 1 1 auto;
  color: var(--left-nav-on-bg);
  font-size: 0.98rem;
  line-height: 1.2;
}
.left-nav-caret {
  flex: 0 0 auto;
  color: var(--left-nav-on-bg-muted);
  font-size: 0.72rem;
}
.left-nav-panel.is-collapsed .left-nav-caret {
  position: absolute;
  right: 0.3rem;
  top: 50%;
  transform: translateY(-50%);
}
.left-nav-badge,
.left-nav-subbadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.05rem;
  height: 1.05rem;
  padding: 0 0.28rem;
  border-radius: 999px;
  background: var(--bs-warning);
  color: var(--left-nav-badge-text);
  font-size: 0.625rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}
.left-nav-badge {
  position: absolute;
  top: -0.3rem;
  left: -0.55rem;
}
.left-nav-panel:not(.is-collapsed) .left-nav-badge {
  top: -0.18rem;
  right: -0.2rem;
  left: auto;
}
.left-nav-separator {
  height: 1px;
  margin: 0.15rem 0.45rem;
  background: var(--left-nav-line);
}
.left-nav-inline-submenu {
  margin-top: 0.35rem;
  padding-left: 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}
.left-nav-subtrigger {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  min-height: 2.5rem;
  padding: 0.55rem 0.85rem;
  border-radius: 0.85rem;
  color: color-mix(in srgb, var(--white) 92%, transparent);
  transition: background-color 180ms ease, color 180ms ease;
}
.left-nav-subtrigger.is-active,
.left-nav-subtrigger:active {
  background: var(--left-nav-hover);
  color: var(--left-nav-on-bg);
}
.left-nav-subtoggle,
.left-nav-flyout-toggle {
  border-radius: 0.85rem;
}
.left-nav-subtoggle {
  padding: 0.55rem 0.85rem;
  color: color-mix(in srgb, var(--white) 92%, transparent);
  transition: background-color 180ms ease;
}
.left-nav-subtoggle ::ng-deep .flip-row {
  width: 100%;
}
.left-nav-subtoggle ::ng-deep .flip-text {
  color: inherit;
  font-size: 0.92rem;
}
.left-nav-subicon,
.left-nav-flyout-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 1.1rem;
  min-width: 1.1rem;
  line-height: 1;
  text-align: center;
}
.left-nav-sublabel,
.left-nav-flyout-label {
  flex: 1 1 auto;
}
.left-nav-footer {
  margin-top: auto;
  padding: 0.5rem 0.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.9rem;
  justify-content: center;
  flex: 0 0 auto;
}
.left-nav-footer-separator {
  align-self: stretch;
  width: auto;
  margin: 0.15rem 0.45rem;
}
.left-nav-account-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border: 0;
  border-radius: 999px;
  background: color-mix(in srgb, var(--white) 8%, transparent);
  transition: background-color 180ms ease, transform 120ms cubic-bezier(0.23, 1, 0.32, 1);
}
.left-nav-account-trigger.is-open {
  background: color-mix(in srgb, var(--white) 18%, transparent);
}
.left-nav-logout-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--left-nav-logout);
  transition:
    background-color 180ms ease,
    color 180ms ease,
    transform 120ms cubic-bezier(0.23, 1, 0.32, 1);
}
.left-nav-account-trigger:active,
.left-nav-logout-trigger:active {
  transform: scale(0.94);
}
.left-nav-account-menu {
  position: absolute;
  left: calc(100% - 0.2rem);
  bottom: 0.75rem;
  min-width: 15rem;
  max-width: 18rem;
  padding: 0.55rem;
  border-radius: 0.9rem;
  background: var(--left-nav-submenu-bg);
  color: var(--left-nav-submenu-text);
  box-shadow: var(--left-nav-menu-shadow);
  z-index: 1100;
  transform-origin: left bottom;
  animation: left-nav-menu-in 160ms cubic-bezier(0.23, 1, 0.32, 1) backwards;
}
.left-nav-account-heading {
  padding: 0.45rem 0.6rem 0.65rem;
  font-size: 0.85rem;
  font-weight: 600;
}
.left-nav-account-item,
.left-nav-account-subitem {
  width: 100%;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}
.left-nav-account-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 2.65rem;
  padding: 0.7rem 0.8rem;
  border-radius: 0.8rem;
  transition: background-color 180ms ease;
}
.left-nav-account-item.is-expandable {
  justify-content: space-between;
}
.left-nav-account-item-main {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
}
.left-nav-account-item:active {
  background: var(--brand-on-primary);
}
.left-nav-account-submenu {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin: 0.2rem 0 0.45rem;
  padding-left: 0.55rem;
  max-height: 14rem;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--brand-primary) 22%, transparent) transparent;
}
.left-nav-account-submenu::-webkit-scrollbar {
  width: 0.4rem;
}
.left-nav-account-submenu::-webkit-scrollbar-track {
  background: transparent;
}
.left-nav-account-submenu::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--brand-primary) 22%, transparent);
}
.left-nav-account-subitem {
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
  padding: 0.55rem 0.7rem;
  border-radius: 0.75rem;
  transition: background-color 180ms ease;
}
.left-nav-account-subitem.active,
.left-nav-account-subitem:active {
  background: color-mix(in srgb, var(--white) 72%, transparent);
}
.left-nav-account-note {
  padding: 0.45rem 0.7rem 0.6rem;
  color: color-mix(in srgb, var(--brand-warning) 45%, var(--black));
  font-size: 0.75rem;
  line-height: 1.35;
}
.left-nav-account-description {
  color: color-mix(in srgb, var(--brand-primary) 70%, transparent);
  line-height: 1.35;
}
.left-nav-flyout {
  position: absolute;
  left: calc(100% - 0.2rem);
  min-width: 12rem;
  max-width: 16rem;
  padding: 0.55rem;
  border-radius: 0.9rem;
  background: var(--left-nav-submenu-bg);
  color: var(--left-nav-submenu-text);
  box-shadow: var(--left-nav-menu-shadow);
  z-index: 1100;
  transform-origin: left top;
  animation: left-nav-menu-in 160ms cubic-bezier(0.23, 1, 0.32, 1) backwards;
}
.left-nav-flyout-title {
  padding: 0.35rem 0.5rem 0.55rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: color-mix(in srgb, var(--brand-primary) 76%, transparent);
}
.left-nav-flyout-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.left-nav-flyout-trigger {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  min-height: 2.75rem;
  padding: 0.7rem 0.8rem;
  border-radius: 0.8rem;
  color: var(--left-nav-submenu-text);
  transition: background-color 180ms ease, color 180ms ease;
}
.left-nav-flyout-trigger.is-active,
.left-nav-flyout-trigger:active {
  background: var(--brand-on-primary);
}
.left-nav-flyout-toggle {
  padding: 0.7rem 0.8rem;
  color: var(--left-nav-submenu-text);
  transition: background-color 180ms ease, color 180ms ease;
}
.left-nav-flyout-toggle ::ng-deep .flip-row {
  width: 100%;
}
.left-nav-flyout-toggle ::ng-deep .flip-text {
  color: inherit;
  font-size: 0.92rem;
}
.left-nav-trigger:focus-visible,
.left-nav-subtrigger:focus-visible,
.left-nav-account-trigger:focus-visible,
.left-nav-logout-trigger:focus-visible,
.left-nav-header a:focus-visible {
  outline: 2px solid var(--white);
  outline-offset: 2px;
}
.left-nav-flyout-trigger:focus-visible,
.left-nav-account-item:focus-visible,
.left-nav-account-subitem:focus-visible {
  outline: 2px solid var(--brand-primary);
  outline-offset: -2px;
}
@media (hover: hover) and (pointer: fine) {
  .left-nav-trigger:hover:not(.is-active) .left-nav-icon-wrap {
    background: var(--left-nav-chip-hover);
  }
  .left-nav-subtrigger:hover,
  .left-nav-subtoggle:hover {
    background: var(--left-nav-hover);
    color: var(--left-nav-on-bg);
  }
  .left-nav-scroll::-webkit-scrollbar-thumb:hover {
    background: color-mix(in srgb, var(--white) 40%, transparent);
  }
  .left-nav-account-trigger:hover {
    background: color-mix(in srgb, var(--white) 18%, transparent);
  }
  .left-nav-logout-trigger:hover {
    background: color-mix(in srgb, var(--white) 10%, transparent);
    color: var(--left-nav-logout-hover);
  }
  .left-nav-account-item:hover,
  .left-nav-flyout-trigger:hover,
  .left-nav-flyout-toggle:hover {
    background: var(--brand-on-primary);
  }
  .left-nav-account-subitem:hover {
    background: color-mix(in srgb, var(--white) 72%, transparent);
  }
  .left-nav-account-submenu::-webkit-scrollbar-thumb:hover {
    background: color-mix(in srgb, var(--brand-primary) 34%, transparent);
  }
}
@media (max-width: 767px) {
  .left-nav-account-menu,
  .left-nav-flyout {
    left: calc(100% - 0.05rem);
    min-width: 11.5rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  .left-nav-account-menu,
  .left-nav-flyout {
    animation: left-nav-fade-in 120ms ease backwards;
  }
  .left-nav-trigger:active .left-nav-icon-wrap,
  .left-nav-account-trigger:active,
  .left-nav-logout-trigger:active {
    transform: none;
  }
}
.left-nav-environment-badge {
  position: absolute;
  top: 0.05rem;
  right: -0.75rem;
  z-index: 3;
  padding: 0;
  background: transparent;
  border: 0;
}
:host ::ng-deep .left-nav-environment-badge-value {
  background: var(--brand-warning) !important;
  color: var(--brand-text) !important;
  padding: 0.2rem 0.4rem;
  border-radius: 999px;
  box-shadow: 0 2px 6px color-mix(in srgb, var(--black) 40%, transparent);
  font-size: 0.65rem;
  font-weight: 400;
  white-space: nowrap;
}
@keyframes left-nav-menu-in {
  from {
    opacity: 0;
    transform: translateX(-4px) scale(0.97);
  }
}
@keyframes left-nav-fade-in {
  from {
    opacity: 0;
  }
}
/*# sourceMappingURL=left-nav.component.css.map */
